module.exports = __webpack_public_path__ + "assets/media/day20.fc460fbc.mp3";